






































import { Component, Prop } from 'vue-property-decorator';
import { IUser, UserStatus } from 'admiral-core';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon, UserIcon } from 'vue-feather-icons';
import { FormatMixin } from '@/mixins/FormatMixin';
@Component({
  components: { Multiselect, Avatar, CheckIcon, UserIcon },
})
export default class UserSelect extends mixins(BaseMixin, FormatMixin) {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop({ type: Boolean, default: () => false })
  allowEmpty!: boolean;

  @Prop({ type: Array, required: false })
  options!: IUser[];

  @Prop({ type: Boolean, default: () => false })
  notAssigned!: boolean;

  get filteredUsers() {
    const users =
      this.options ||
      this.users.filter((user: IUser) =>
        [UserStatus.ACTIVE, UserStatus.PENDING].includes(user.status),
      );

    if (this.notAssigned) {
      return [{ id: '' } as IUser, ...users];
    }

    return users;
  }

  @Prop()
  u!: IUser | IUser[];

  updateUser(user: IUser | IUser[]) {
    this.$emit('update-user', user);
  }

  isSelected(id: string) {
    if (!this.u) {
      return false;
    }
    if (Array.isArray(this.u)) {
      return this.u.find((user: IUser) => user.id === id);
    } else {
      return this.u.id === id;
    }
  }
}
